import _defineProperty from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Button } from './Button';
import { Spinner } from '../Spinner/Spinner';
export var BusyButton = /*#__PURE__*/function (_React$Component) {
  _inherits(BusyButton, _React$Component);

  var _super = _createSuper(BusyButton);

  function BusyButton() {
    var _this;

    _classCallCheck(this, BusyButton);

    _this = _super.apply(this, arguments);
    _this.buttonRef = React.createRef();
    _this.state = {
      width: undefined,
      height: undefined
    };
    return _this;
  }

  _createClass(BusyButton, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if (this.buttonRef.current && prevProps.isBusy !== this.props.isBusy && prevProps.children === this.props.children && this.props.isBusy === true) {
        var rect = this.buttonRef.current.getBoundingClientRect();
        return {
          width: rect.width,
          height: rect.height
        };
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (snapshot !== null) {
        this.setState({
          width: snapshot.width,
          height: snapshot.height
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$isBusy = _this$props.isBusy,
          isBusy = _this$props$isBusy === void 0 ? false : _this$props$isBusy,
          children = _this$props.children,
          lss = _this$props.lss,
          props = _objectWithoutProperties(_this$props, ["isBusy", "children", "lss"]);

      return React.createElement(Button, Object.assign({
        ref: this.buttonRef,
        disabled: isBusy || props.disabled
      }, props, {
        lss: _objectSpread({
          width: this.state.width,
          height: this.state.height
        }, lss)
      }), isBusy ? React.createElement(Spinner, {
        height: 11
      }) : children);
    }
  }]);

  return BusyButton;
}(React.Component);
BusyButton.defaultProps = {
  minWidth: 150
};

var AsyncBusyButton = /*#__PURE__*/function (_React$Component2) {
  _inherits(AsyncBusyButton, _React$Component2);

  var _super2 = _createSuper(AsyncBusyButton);

  function AsyncBusyButton() {
    var _this2;

    _classCallCheck(this, AsyncBusyButton);

    _this2 = _super2.apply(this, arguments);
    _this2.state = {
      isBusy: false
    };
    _this2.buttonMounted = false;

    _this2.handleClick = function (ev) {
      _this2.setState({
        isBusy: true
      });

      Promise.resolve(_this2.props.onClick(ev)).finally(function () {
        if (_this2.buttonMounted) {
          _this2.setState({
            isBusy: false
          });
        }
      });
    };

    return _this2;
  }

  _createClass(AsyncBusyButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.buttonMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.buttonMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(BusyButton, Object.assign({
        isBusy: this.state.isBusy
      }, this.props, {
        onClick: this.handleClick
      }));
    }
  }]);

  return AsyncBusyButton;
}(React.Component);

BusyButton.Async = AsyncBusyButton;